import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { getCoords } from "../utils/utils";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    gsap.delayedCall(0.5, () => {
      if (Env.mobile) {
        console.log(this.ref.toto);
        this.sticky();
      }
    });
  }

  sticky() {
    this.instance = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: `top bottom`,
      end: "bottom bottom",
      markers: true,
      pin: this.ref.toto[0],
      pinSpacing: false,
    });
  }

  unmount() {
    this.instance.kill();
  }
}
